/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AbsenceDepartmentDutyRosterResult,
  DepartmentDutyRosterResult,
  GetForExistingLeaveRequestParams,
  GetForNewLeaveRequestParams,
  MyWorkareaDutyRosterParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetForNewLeaveRequestUrl = (params?: GetForNewLeaveRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest`
}

export const getForNewLeaveRequest = async (params?: GetForNewLeaveRequestParams, options?: Parameters<typeof customInstance>[1]): Promise<AbsenceDepartmentDutyRosterResult> => {

  return customInstance<AbsenceDepartmentDutyRosterResult>(getGetForNewLeaveRequestUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForNewLeaveRequestQueryKey = (params?: GetForNewLeaveRequestParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/GetForNewLeaveRequest`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetForNewLeaveRequestQueryOptions = <TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForNewLeaveRequestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForNewLeaveRequest>>> = ({ signal }) => getForNewLeaveRequest(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetForNewLeaveRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getForNewLeaveRequest>>>
export type GetForNewLeaveRequestQueryError = ErrorType<unknown>


export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForNewLeaveRequestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForNewLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForNewLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForNewLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForNewLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetForNewLeaveRequest<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetForNewLeaveRequestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetForNewLeaveRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForNewLeaveRequestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForNewLeaveRequest>>> = ({ signal }) => getForNewLeaveRequest(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetForNewLeaveRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getForNewLeaveRequest>>>
export type GetForNewLeaveRequestSuspenseQueryError = ErrorType<unknown>


export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForNewLeaveRequestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetForNewLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForNewLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForNewLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetForNewLeaveRequestSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetForExistingLeaveRequestUrl = (params?: GetForExistingLeaveRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest`
}

export const getForExistingLeaveRequest = async (params?: GetForExistingLeaveRequestParams, options?: Parameters<typeof customInstance>[1]): Promise<AbsenceDepartmentDutyRosterResult> => {

  return customInstance<AbsenceDepartmentDutyRosterResult>(getGetForExistingLeaveRequestUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetForExistingLeaveRequestQueryKey = (params?: GetForExistingLeaveRequestParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/GetForExistingLeaveRequest`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetForExistingLeaveRequestQueryOptions = <TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForExistingLeaveRequestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForExistingLeaveRequest>>> = ({ signal }) => getForExistingLeaveRequest(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetForExistingLeaveRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getForExistingLeaveRequest>>>
export type GetForExistingLeaveRequestQueryError = ErrorType<unknown>


export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForExistingLeaveRequestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>,
          TError,
          Awaited<ReturnType<typeof getForExistingLeaveRequest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetForExistingLeaveRequest<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetForExistingLeaveRequestQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetForExistingLeaveRequestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForExistingLeaveRequestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForExistingLeaveRequest>>> = ({ signal }) => getForExistingLeaveRequest(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetForExistingLeaveRequestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getForExistingLeaveRequest>>>
export type GetForExistingLeaveRequestSuspenseQueryError = ErrorType<unknown>


export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params: undefined |  GetForExistingLeaveRequestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetForExistingLeaveRequestSuspense<TData = Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError = ErrorType<unknown>>(
 params?: GetForExistingLeaveRequestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getForExistingLeaveRequest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetForExistingLeaveRequestSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMyWorkareaDutyRosterUrl = (params?: MyWorkareaDutyRosterParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster?${stringifiedParams}` : `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster`
}

export const myWorkareaDutyRoster = async (params?: MyWorkareaDutyRosterParams, options?: Parameters<typeof customInstance>[1]): Promise<DepartmentDutyRosterResult> => {

  return customInstance<DepartmentDutyRosterResult>(getMyWorkareaDutyRosterUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMyWorkareaDutyRosterQueryKey = (params?: MyWorkareaDutyRosterParams,) => {
    return [
    `/api/AbsenceDepartmentDutyRoster/MyWorkareaDutyRoster`, ...(params ? [params] : [])
    ] as const;
    }


export const getMyWorkareaDutyRosterQueryOptions = <TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMyWorkareaDutyRosterQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myWorkareaDutyRoster>>> = ({ signal }) => myWorkareaDutyRoster(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MyWorkareaDutyRosterQueryResult = NonNullable<Awaited<ReturnType<typeof myWorkareaDutyRoster>>>
export type MyWorkareaDutyRosterQueryError = ErrorType<unknown>


export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params: undefined |  MyWorkareaDutyRosterParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>,
          TError,
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>,
          TError,
          Awaited<ReturnType<typeof myWorkareaDutyRoster>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMyWorkareaDutyRoster<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyWorkareaDutyRosterQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMyWorkareaDutyRosterSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMyWorkareaDutyRosterQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof myWorkareaDutyRoster>>> = ({ signal }) => myWorkareaDutyRoster(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type MyWorkareaDutyRosterSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof myWorkareaDutyRoster>>>
export type MyWorkareaDutyRosterSuspenseQueryError = ErrorType<unknown>


export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params: undefined |  MyWorkareaDutyRosterParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMyWorkareaDutyRosterSuspense<TData = Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError = ErrorType<unknown>>(
 params?: MyWorkareaDutyRosterParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof myWorkareaDutyRoster>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMyWorkareaDutyRosterSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






